import {getNodeId} from "./Util";
import {LIDAR_TESTER, LIDAR_TESTER_ACTIVATION_PERIOD_MINUTES} from "./Constants";


// The function takes in a column Label and rowLabel and returns the Label to be displayed on UI
// example for OV column containing T and U bins, we need to show "TU" on UI and so on

// The column here refers to the column in the racks at the delivery station, where the
// packages are stowed. for example column B in aisle A1: (it will have 4 bins: A1-1B, A1-2B, A1-3B, A1-4B)
export const getDisplayableColumnLabel = (columnLabel, rowLabels) => {
    if (rowLabels) {
        let label = "";
        rowLabels.forEach(rowLabel => {
            label = label + rowLabel[rowLabel.length - 1]
        })
        return label;
    }
    return columnLabel[columnLabel.length - 1];
}

// The function takes in the lidar controller device and returns an exhaustive list of all the
// columns present in any of the aisles served by this controller.
export const getExhaustiveLabelSet = (device) => {
    let labelSet = new Set();
    device.displayableAssetMappings.forEach(assetMapping => {
        assetMapping.columns.forEach(column => {
            labelSet.add(getDisplayableColumnLabel(column.columnLabel, column.rowLabels))
        })
    })
    return new Array(...labelSet).sort();
}

// The function takes in the lidar controller device and return the list of
// column mappings for each aisle, sorted in ascending order i.e. A1 comes first, then A2 and so on
export const getSortedAssetByAisle = (device) => {
    return [...device.displayableAssetMappings.sort((a, b) => {
        return a.aisleLabel.localeCompare(b.aisleLabel, undefined, {
            numeric: true,
            sensitivity: 'base'
        });
    })]
}

// The function takes in the sensor state values for a particular column
// and returns an array, each entry representing a single Lidar sensor.
export const getColumnSensorStateValues = (columnSensorStates) => {
    let values = []
    Object.keys(columnSensorStates).forEach((key) => {
        values.push({...columnSensorStates[key]["0"]})
        values.push({...columnSensorStates[key]["1"]})
    })
    return values;
}

// The function removes the "-" from aisle Label to maintain uniformity across regions.
export const formatAisleLabel = (aisleLabel) => {
    return aisleLabel.replace("-", "");
}

// The function returns the mqtt topic to subscribe for listening to
// lidar events of a particular lidar controller
export const getMqttTopicForLidarTester = (nodeId, ip) => {
    return "site/" + nodeId + "/lidarTester/" + ip
}

// The function returns the Lidar Tester activation request object.
export const getLidarTesterActivationRequest = () => {
    return {
        nodeId: getNodeId(),
        commandType: LIDAR_TESTER,
        commandParams: JSON.stringify({
            event: LIDAR_TESTER,
            period: LIDAR_TESTER_ACTIVATION_PERIOD_MINUTES
        })
    }
}

// The function classifies a column label as OV or non-OV
export const isOVColumnLabel = (label) => {

    // To-Do: Explore a better way for this
    return label > "L";
}



// WEBPACK FOOTER //
// ./src/components/util/LidarTesterUtil.js